import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getWeight(page) {
  const data = await getFetch(`/Weight?q=&page=${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeWeight(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'وزن الزامی است!',
    }
  }

  const res = await postFetchWithToken("/Weight/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'وزن با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }
}
async function deleteWeight(id) {
  const res = await postFetchWithBody(`/Weight/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getWeight, storeWeight,deleteWeight };
